import React, { SVGProps } from 'react';

export const LeaderboardIcon: React.FC<SVGProps<any>> = ({
  fill = '#0CD664',
}) => {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 25 24'
      width='25'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.5605 11V3H8.56055V9H2.56055V21H22.5605V11H16.5605ZM10.5605 5H14.5605V19H10.5605V5ZM4.56055 11H8.56055V19H4.56055V11ZM20.5605 19H16.5605V13H20.5605V19Z'
        fill={fill}
      />
    </svg>
  );
};
